import { Component } from 'preact'
import EmptyTrashModal from './EmptyTrashModal'
/* eslint-disable import/no-internal-modules */
import { emptyTrash } from './service'
import Button from '@insided/control/uikit/Button'
import { publish } from '@insided/deprecated-utils/globals'

interface EmptyTrashActionState {
  showEmptyTrashModal: boolean
}

class EmptyTrash extends Component<{}, EmptyTrashActionState> {
  constructor() {
    super()
    this.state = {
      showEmptyTrashModal: false
    }

    this.onEmptyTrash = this.onEmptyTrash.bind(this)
  }

  async onEmptyTrash() {
    const successMessage = `We're taking out the trash, this can take up to a few minutes to complete. Please come back later :)`
    const errorMessage = 'Something went wrong. Please try again.'
    try {
      await emptyTrash()
      publish('show_alert', { alertType: 'success', message: successMessage })
    } catch {
      publish('show_alert', { alertType: 'error', message: errorMessage })
    }
    this.setState({ showEmptyTrashModal: false })
  }

  render() {
    const { showEmptyTrashModal } = this.state

    return (
      <div>
        <Button
          title='Empty Trash'
          size='medium'
          variant='warning'
          data-qa='empty-trash'
          startIcon='trash'
          onClick={() => this.setState({ showEmptyTrashModal: true })}
        />
        {showEmptyTrashModal && <EmptyTrashModal
          onEmptyTrash={this.onEmptyTrash}
          onClose={() => this.setState({ showEmptyTrashModal: false })}
        />}
      </div>
    )
  }
}

export default EmptyTrash
